import axios from "axios";

export default {
    // namespaced: true,
    state: {
        dialog: false,
        id: '',
        nombre: '',
        clientesDisponibles: [],
        loadingClientes: false,
        itemsPorPag: 10,
        pagActual: 1,
    },
    mutations: {
        SET_CLIENTE(state, cliente) {
            state.id = cliente.id;
            state.nombre = cliente.nombre;
        },
        SET_DIALOG(state, mostrar) {
            state.dialog = mostrar
        },
        SET_CLIENTES_DISPONIBLES(state, clientes) {
            state.clientesDisponibles = null
            state.clientesDisponibles = clientes
        },
        SET_LOADING_CLIENTES(state, loading) {
            state.loadingClientes = loading;
        },
        SET_PAGINACION(state, pagActual) {
            state.pagActual = pagActual;
        }

    },
    actions: {
        setCliente({
            commit
        }, cliente) {
            console.log(cliente);
            commit('SET_CLIENTE', cliente);
        },
        setDialog({
            commit
        }, mostrar) {
            commit('SET_DIALOG', mostrar);
        },
        getClientesDisponibles({
            commit,
            dispatch
        }, cache) {
            // this.loadingClientes = true;
            commit('SET_LOADING_CLIENTES', true);
            let cacheQuery = cache ? "cache=0" : "cache=1";
            axios
                .get(`api/clientes?${cacheQuery}`)
                .then((res) => {
                    let clientes = res.data.map((item) => {
                        return {
                            value: item.code,
                            text: item.name,
                            ...item
                        };
                    });
                    // this.loadingClientes = false;
                    commit('SET_CLIENTES_DISPONIBLES', clientes)
                    commit('SET_LOADING_CLIENTES', false);
                })
                .catch((err) => {
                    // this.loadingClientes = false;
                    commit('SET_LOADING_CLIENTES', false);

                    console.log(err);
                    dispatch('setSnackbar', {
                        tipo: "error",
                        mensaje: "Error. No se han podido recuperar los clientes",
                    });
                });
        },
        setPaginacion({commit}, pagActual){
            commit('SET_PAGINACION', pagActual);
        }
    },
    getters: {
        clientesDisponibles: state => state.clientesDisponibles,
        loadingClientes: state => state.loadingClientes,
        pagActual: state => state.pagActual,
        itemsPorPag: state => state.itemsPorPag,
    }
}